import React from "react";
import { useNavigate } from "react-router-dom";

const SpinSVG = () => (
  <svg width="18" height="18" viewBox="0 0 15 15" fill="none"
    style={{ animation: "spin 0.8s linear infinite", flexShrink: 0 }}>
    <circle cx="7.5" cy="7.5" r="5.5" stroke="currentColor" strokeOpacity=".3" strokeWidth="2.5" fill="none" />
    <path d="M7.5 2A5.5 5.5 0 0 1 13 7.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" fill="none" />
  </svg>
);

const FormIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
  </svg>
);

export default function CommonFormLayout({ mode, loading, btnLoading, headerProps, onSubmit, hideFooter, footerContent, children }) {
  const navigate = useNavigate();

  const title =
    mode === "edit"
      ? headerProps?.updateMessage
      : mode === "view"
      ? `View ${headerProps?.homeText}`
      : headerProps?.addMessage;

  const subtitle =
    mode === "view"
      ? headerProps?.homeText
      : mode === "edit"
      ? `Editing · ${headerProps?.homeText}`
      : `Fill in the details below`;

  const handleClose = () => {
    if (headerProps?.homeLink) {
      navigate(headerProps.homeLink);
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <div className="ems-drawer-backdrop" onClick={handleClose} />

      <div className="ems-form-drawer">
        {/* Header */}
        <div className="ems-fd-head">
          <div className="ems-fd-ic">
            <FormIcon />
          </div>
          <div className="ems-fd-titles">
            <div className="ems-fd-title">{title}</div>
            <div className="ems-fd-sub">{subtitle}</div>
          </div>
          <button className="ems-fd-close" onClick={handleClose} title="Close">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="ems-fd-body">
          {loading ? (
            <div className="ems-fm-loading"><SpinSVG /></div>
          ) : (
            <div className="ems-fm-body">{children}</div>
          )}
        </div>

        {/* Footer */}
        {hideFooter && footerContent ? (
          <div className="ems-fd-foot">{footerContent}</div>
        ) : (
          !hideFooter &&
          mode !== "view" && (
            <div className="ems-fd-foot">
              <button className="ems-btn ems-ghost" onClick={handleClose}>
                Cancel
              </button>
              <button
                className="ems-btn ems-primary"
                onClick={onSubmit}
                disabled={loading || btnLoading}
              >
                {loading || btnLoading ? (
                  <><SpinSVG />{mode === "edit" ? "Updating…" : "Submitting…"}</>
                ) : (
                  mode === "edit" ? "Update" : "Submit"
                )}
              </button>
            </div>
          )
        )}
      </div>
    </>
  );
}
